const UTM_STORAGE_KEY = 'careerfy_utm_params';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

/**
 * Capture UTM params from the current URL and persist to sessionStorage.
 * Call once on app mount (e.g. in TrackingProvider).
 */
export function captureUTMFromURL(): UTMParams | null {
  if (typeof window === 'undefined') return null;

  const url = new URL(window.location.href);
  const params: UTMParams = {};
  let hasAny = false;

  for (const key of UTM_KEYS) {
    const value = url.searchParams.get(key);
    if (value) {
      params[key] = value;
      hasAny = true;
    }
  }

  if (hasAny) {
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params));
    return params;
  }

  return getUTMParams();
}

/**
 * Retrieve stored UTM params (returns null if none captured this session).
 */
export function getUTMParams(): UTMParams | null {
  if (typeof window === 'undefined') return null;

  const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
  if (!stored) return null;

  try {
    return JSON.parse(stored) as UTMParams;
  } catch {
    return null;
  }
}
